import { IAction } from '@/types/redux';
import { Map } from 'immutable';
import { ensureImmutable } from '@/utils/safeImmutable'; // FIX: Import helper

// The initial state of the Main
const initialState = Map({
  sessionToken: null,
});

function appReducer(state = initialState, action: IAction) {
  // FIX: Defensive check
  const immutableState = ensureImmutable(state) || initialState;

  switch (action.type) {
    default:
      return immutableState;
  }
}

export default appReducer;